<template>
    <div>
        <template v-if="crud_designation === true">
            <div class="container">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left">Edit Designation</h1>
                </div>
                <div class="global-main">
                    <form @submit.prevent="editDesignationData">
                        <div class="tab-content-inner">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label> Name </label>
                                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                        <has-error :form="form" field="name"></has-error>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <label> Departments </label>
                                        <select v-model="form.department_id" data-live-search="true" name="department_id" autocomplete="off" 
                                        class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('department_id') }">
                                            <option value="">Select Department</option>
                                            <option v-for="department in departments" v-bind:value="department.id" v-bind:key="department.id">{{ department.name }}</option>
                                        </select>
                                        <has-error :form="form" field="department_id"></has-error>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label> Job Description </label>
                                        <input v-model="form.designation_description" type="text" name="designation_description" class="form-control" :class="{ 'is-invalid': form.errors.has('designation_description') }">
                                        <has-error :form="form" field="designation_description"></has-error>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                            <router-link to="/designations" class="btn btn-primary float-right mr-2">Cancel</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-if="crud_designation === null"><preLoader></preLoader></template>
        <template v-if="crud_designation === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                departments : null,
                form: new Form({
                    name : '',
                    department_id : '',
                    designation_description : '',
                }),
                crud_designation : null,
            };
        },
        methods: {
            editDesignationData() {
                this.$Progress.start();
                this.form.put('/api/updateDesignation')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','Designation updated successfully');
                            this.$router.push('/designations');
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    });
            },
            getDesignationData(){
                axios.get('/api/editDesignation/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.id = res.data.id;
                        this.form.name = res.data.name;
                        this.form.department_id = res.data.department_id;
                        this.form.designation_description = res.data.designation_description;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .then(()=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                });
            },
            getDepartments() 
            {
                this.$Progress.start();
                this.form.get('/api/getDepartments')
                .then(res => {
                    if(res.data.code == 200)
                    {
                        this.departments = res.data.data;
                        this.$Progress.finish();
                    }
                    else
                    {
                        this.$Progress.fail();
                    }
                })
                .then(()=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in fetching data for departments');
                });
            },
        },
        mounted() 
        {
            this.$Progress.start();
            this.can('crud_designation').then(result=>{
                this.crud_designation = result.crud_designation;
            }).then(result=>{
                if(this.crud_designation === true){
                    this.getDesignationData();
                    this.getDepartments();                
                }
            });
        }
    }
</script>